// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"6bacc4d8","318":"39ba86f0","386":"9bb251f0","511":"42bbfa76","650":"01290922","653":"a3dadd56"}[chunkId] + ".chunk.js";
};